import React from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { ReactComponent as Discord } from '../assets/svgs/discord.svg';
import { MENU } from "../config";

import './pages.css';

function HomePage() {
    const intl = useIntl();
    const added = intl.formatMessage({ id: 'home.added', defaultMessage: 'Added' });
    return (
        <div className="page">
            <div className="main-container">
                <div className="surround-margin" />
                <div className="sub-container">
                    <div className="home-page">
                        <div className="home-title">
                            <img className="home-icon" src={MENU.icon_l} alt="Icon"></img>
                            <h1 className="main-title">
                                <FormattedMessage
                                    id="main.title"
                                    defaultMessage="The Eminence in Codex"
                                />
                            </h1>
                        </div>
                        <FormattedMessage id="home.created" defaultMessage="Created by" />
                        <div className="discord-container">
                            <a href="https://discord.com/users/275700883684196352" target="_blank" rel="noopener noreferrer">
                                <Discord className="discord-icon" />nekuko
                            </a>
                        </div>
                        <FormattedMessage id="home.thanks" defaultMessage="Thanks to those who helped collect the data, and additional thanks to Cynthia for providing French translations." />
                        <h2>
                            <FormattedMessage
                                id="home.changelog"
                                defaultMessage="Changelog"
                            />
                        </h2>
                        <div className="changelog">
                            <span>06/02/2025 - {added} "Delta (I Hunted It!) - Lady Alpha's Errand Note"</span>
                            <span>05/02/2025 - Hello World</span>
                        </div>
                    </div>
                </div>
                <div className="surround-margin" />
            </div>
        </div >
    )
}

export default HomePage;